import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/Layout.vue";
import NotFound from "@/components/404.vue"
import store from '@/store'
Vue.use(VueRouter);

const routes = [
  {
    path: "",
    redirect: "/index",
  },
  {
    path: "*", // 匹配所有路径
    component: NotFound,
  },
  {
    path: "/layout",
    component: Layout,
    children: [
      {
        path: "/index",
        name: "Index",
        component: () => import("@/views/home/index.vue"),
        meta:{
          title:''
        }
      },
      {
        path: "/programme",
        name: "programme",
        component: () => import("@/views/programme/index.vue"),
        meta:{
          title:'解决方案'
        }
      },
      {
        path: "/introduce",
        name: "Introduce",
        component: () => import("@/views/introduce/index.vue"),
        meta:{
          title:'解决方案-详情'
        }
      },
      {
        path: "/product",
        name: "Product",
        component: () => import("@/views/product/index.vue"),
        meta:{
          title:'产品介绍'
        }
      },
      {
        path: "/product/product-details",
        name: "ProductDetails",
        component: () => import("@/views/product/details/index.vue"),
        meta:{
          title:'产品介绍-详情'
        }
      },
      {
        path: "/product-details-list",
        name: "ProductDetailsList",
        component: () =>
          import("@/views/product/product-details-list/index.vue"),
        meta:{
          title:'产品介绍'
        }
      },
      {
        path: "/case",
        name: "Case",
        component: () => import("@/views/case/index.vue"),
        meta:{
          title:'客户案例'
        }
      },
      {
        path: "/case/details",
        name: "CaseDetails",
        component: () => import("@/views/case/details/index.vue"),
        meta:{
          title:'客户案例-详情'
        }
      },
      {
        path: "/news",
        name: "News",
        component: () => import("@/views/news/index.vue"),
        meta:{
          title:'新闻资讯'
        }
      },
      {
        path: "/news/details",
        name: "NewsDetails",
        component: () => import("@/views/news/details/index.vue"),
        meta:{
          title:'新闻资讯-详情'
        }
      },
      {
        path: "/about",
        name: "About",
        component: () => import("@/views/about/index.vue"),
        meta:{
          title:'关于我们'
        }
      },
      {
        path: "/qualifications",
        name: "Qualifications",
        component: () => import("@/views/qualifications/index.vue"),
        meta:{
          title:'资质详情'
        }
      },
      {
        path: "/about/partner",
        name: "AboutPartner",
        component: () => import("@/views/about/partner/index.vue"),
        meta:{
          title:'合作伙伴'
        }
      },
      {
        path: "/about/partner/details",
        name: "AboutPartnerDetails",
        component: () => import("@/views/about/partner/details/index.vue"),
        meta:{
          title:'合作伙伴-详情'
        }
      },
    ],
  },
];



const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const config = await store.dispatch("getConfig");
  if(config.settingTitle.configValue){
    if(to?.meta?.title){
      document.title = to?.meta?.title + " " + config.settingTitle.configValue;
    }else{
      document.title = " " + config.settingTitle.configValue;
    }
    document.querySelector('meta[name="keywords"]').setAttribute("content", config.settingKeywords.configValue);
    document.querySelector('meta[name="description"]').setAttribute("content",  config.settingDescription.configValue);
  }else{
    document.title = to?.meta?.title || "一颗认养";
  }

  next()
})

export default router;
